<template>
    <div class="footer-wrap">
        <div class="footer">
            <div class="footer-top">
                <img src="../../assets/images/home/tab_logo_h.png" alt="甘露海藏医院" class="logo" @click="goHome" />
                <div class="line"></div>
                <nav class="bottom-nav">
                    <router-link :to="item.to" v-for="(item, index) in list" :key="index" class="bottom-nav-link">
                        <div :class="[$route.path.indexOf(item.to) >= 0 ? 'active' : '']" @click="handleNav(item.to)">{{item.name}}</div>
                    </router-link>
                </nav>
            </div>
            <div class="footer-bottom">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010702002154">
                    <img src="../../assets/images/home/beian.png" />
                    <span>粤公网安备 51010702002154号</span>
                </a>
                <a href="https://beian.miit.gov.cn/">
                    <div class="bottom-line"></div>
                    <span>蜀ICP备2020032205号-1</span>
                </a>
            </div>
            <div class="code">
                <img src="../../assets/images/home/pic_ewm.jpg" alt="">
                <span>扫码关注</span>
            </div>
        </div>
        <div class="m-footer">
            <div class="nav">
                <div class="nav-item" v-for="item in list" :key="item.to" @click="handleMenu(item.to)">
                    <span :class="[$route.path.indexOf(item.to) >= 0 ? 'active' : '']">{{item.name}}</span>
                    <div class="line"></div>
                </div>
            </div>
            <div class="code">
                <img src="../../assets/images/home/pic_ewm.jpg" alt="">
                <span>扫码关注</span>
            </div>
            <div class="footer-bottom">
                <a href="http://beian.bizcn.com/">
                    <img src="../../assets/images/home/beian.png" />
                    <span>粤公网安备 51010702002154号</span>
                    <div class="bottom-line"></div>
                    <span>蜀ICP备2020032205号-1</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import Bus from '../../utils/eventBus.js'
    export default {
        data() {
            return {
                list: [
                    { to: "/home", name: "首页" },
                    { to: "/service", name: "健康服务" },
                    { to: "/theSeven", name: "七大第一" },
                    { to: "/team", name: "专家团队" },
                    { to: "/triTone", name: "甘露海模式" },
                    { to: "/groupStrength", name: "集团实力" }
                ],
            }
        },
        methods: {
            handleNav(to) {
                Bus.$emit('pageName', to)
            },
            handleMenu(to){
                if(this.$route.path.indexOf(to) > -1){
                    return
                }
                this.$router.push(to)
            },
            goHome() {
                if(this.$route.path == '/home') return
                this.$router.push('/home')
                Bus.$emit('pageName', '/home')
            }
        }
    }    
</script>
<style lang="scss" scoped>
    .footer {
        width: 100%;
        height: 200px;
        background: #28307C;
        position: relative;
        .footer-top {
            height: 150px;
            width: 100%;
            padding-left: 110px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            .logo {
                width: 286px;
                height: 59px;
                cursor: pointer;
            }
            .line {
                width: 2px;
                height: 27px;
                background: #fff;
                margin-left: 105px;
                margin-right: 122px;
            }
            .bottom-nav {
                .bottom-nav-link {
                    color: rgba(255,255,255,0.6);
                    font-size: 16px;
                    display: inline-block;
                    font-weight: 400;
                    .active {
                        color: #fff;
                        font-weight: bold;
                    }
                }
                .bottom-nav-link:not(:last-child) {
                    margin-right: 76px;
                }
                .bottom-nav-link:hover {
                    color: #fff;
                    font-weight: bold;
                }
            }
        }
        .footer-bottom {
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #fff;
            a {
                // display: inline-block;
                display: flex;
                align-items: center;
                color: rgba(255,255,255,0.42);
                font-size: 12px;
            }
            img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }
            .bottom-line {
                width: 1px;
                height: 16px;
                border-radius: 1px;
                background: rgba(255,255,255,0.6);
                margin-left: 18px;
                margin-right: 30px;
                display: inline-block;
            }
        }
        .code {
            position: absolute;
            right: 110px;
            top: 0;
            height: 100%;
            padding: 20px 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            img {
                width: 118px;
                height: 118px;
            }
            span {
                font-size: 14px;
                color: #fff;
            }
        }
    }
    .m-footer {
        display: none;
    }
    @media screen and (max-width: 800px) {
        .footer {
            display: none;
        }
        .m-footer {
            padding: 50px 60px;
            background: #28307C;
            color: #fff;
            display: block;
            .nav {
                display: flex;
                flex-wrap: wrap;
                .nav-item {
                    width: 30%;
                    height: 150px;
                    font-size: 50px;
                    line-height: 150px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: rgba(255,255,255,0.6);
                    .active {
                        color: #fff;
                        font-weight: bold;
                    }
                    .line {
                        height: 60px;
                        width: 1px;
                        background: rgba(255,255,255,0.6);
                        margin-right: 40%;
                    }
                }
            }
            .code {
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                // align-items: center;
                img {
                    width: 400px;
                    height: 400px;
                }
                span {
                    margin-top: 20px;
                }
            }
            .footer-bottom {
                height: 100px;
                display: flex;
                // justify-content: center;
                align-items: center;
                font-size: 30px;
                color: #fff;
                a {
                    display: flex;
                    align-items: center;
                    color: rgba(255,255,255,0.42);
                    font-size: 40px;
                }
                img {
                    width: 60px;
                    height: 60px;
                    margin-right: 24px;
                }
                .bottom-line {
                    width: 1px;
                    height: 32px;
                    border-radius: 1px;
                    background: rgba(255,255,255,0.6);
                    margin-left: 36px;
                    margin-right: 60px;
                    display: inline-block;
                }
            }
        }
    }
</style>